module.exports = __webpack_public_path__ + "assets/img/index-leftmenu-bg@3x.2cd5c5be.png";